import React, { useEffect, useState } from "react";
import TopBanner from "../components/TopBanner";
import { Outlet } from "react-router-dom";
import { topMenu } from "../Constants";
import { getSystemStatus } from "../API";

function Root() {
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    getSystemStatus().then((s) => setReadOnly(s.readonly === true));
  }, []);

  return (
    <main
      className="d-flex flex-nowrap"
      style={{ flexDirection: "column", height: "100vh" }}
    >
      <TopBanner items={topMenu} />
      {readOnly && (
        <div
          className="alert alert-warning mb-0 text-center py-2 fw-semibold"
          style={{ borderRadius: 0, fontSize: "0.9rem" }}
        >
          Read-only mode — changes must be made in the legacy system. Mobile app uploads are still active.
        </div>
      )}
      <div className="d-flex overflow-hidden h-100">
        <Outlet />
      </div>
    </main>
  );
}

export default Root;
